import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "./firebaseConfig";

import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Songs from "./pages/Songs";
import SongDetail from "./pages/SongDetail";
import Settings from "./pages/Settings";
import QysList from "./pages/QysList";        // ⬅️ NUEVO
import QysDetail from "./pages/QysDetail";    // ⬅️ NUEVO
import Chats from "./pages/Chats";
import ChatDetail from "./pages/ChatDetail";
import RevisionList from "./pages/RevisionList";
import PurchasesTokensList from "./pages/PurchasesTokensList";
import CancionesWebList from "./pages/CancionesWebList";
import CrearCancionWeb from "./pages/CrearCancionWeb";
import CrearCancionDesdeUsuario from "./pages/CrearCancionDesdeUsuario";
import UsersList from "./pages/UsersList";
import UserDetail from "./pages/UserDetail"; // ← reemplaza el placeholder

import SendNotification from "./pages/SendNotification";
import SubirCancion from "./pages/SubirCancion";
import SongUploadTwo from "./pages/SongUpLoadTwo";
import MusicTasksList from "./pages/MusicTasksList";



function App() {
   const [user, setUser] = useState(undefined); // undefined = cargando, null = no logueado

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
    });
    return () => unsub();
  }, []);

  if (user === undefined) {
    return <p>Cargando...</p>;
  }

  if (!user) {
    // Aún no hay sesión → mostramos login
    return <Login onLogin={setUser} />;
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/songs" element={<Songs />} />
          <Route path="/songs/:userId/:songId" element={<SongDetail />} />
          <Route path="/qys" element={<QysList />} />
          <Route path="/qys/:qysId" element={<QysDetail />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/:userId" element={<UserDetail />} />   
          <Route path="/users/:userId/notify" element={<SendNotification />} />     
          <Route path="/chats" element={<Chats />} />
          <Route path="/chats/:chatId" element={<ChatDetail />} />
          <Route path="/revision" element={<RevisionList />} />
          <Route path="/canciones-web" element={<CancionesWebList />} />
          <Route path="/canciones-web/:songId" element={<CrearCancionWeb />} />
          <Route path="/crear-desde-usuario/:usuarioId" element={<CrearCancionDesdeUsuario />} />
          <Route path="/music-tasks" element={<MusicTasksList />} />

           <Route
            path="/subircancion/:userId/:cancionId"
            element={<SubirCancion />}
          />
          <Route path="/upload-two/:usuarioId/:cancionId" element={<SongUploadTwo />} />
          <Route path="/PurchasesTokensList" element={<PurchasesTokensList />} />

          

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
